import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockTableHeader', {
  select: 'Select',
  id: 'ID',
  name: 'Nombre',
  type: 'Tipo',
  store: 'Tienda',
  options: 'Opciones',
  lockPeriod: 'Período de bloqueo'
});

i18next.addResources('es_CR', 'BlockTableHeader', {
  select: 'Select',
  id: 'ID',
  name: 'Nombre',
  type: 'Tipo',
  store: 'Tienda',
  options: 'Opciones',
  lockPeriod: 'Período de bloqueo'
});
